import React from 'react';

import { FieldHint } from './FieldHint';

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  label?: string;
  error?: string;
  hint?: string;
  options: SelectOption[];
  onChange?: (value: string) => void;
  placeholder?: string;
}

export const Select: React.FC<SelectProps> = ({
  label,
  error,
  hint,
  options,
  onChange,
  placeholder,
  className = '',
  value,
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div className="w-full">
      {label && (
        <label
          className="block text-neutral-700 mb-1.5"
          style={{
            fontFamily: 'Oxygen',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '20px',
          }}
        >
          {label}
        </label>
      )}
      <select
        value={value}
        onChange={handleChange}
        className={`w-full px-3 py-2 border rounded-lg text-base transition-colors bg-white cursor-pointer ${
          error
            ? 'border-error-500 focus:ring-error-500'
            : 'border-neutral-300 focus:ring-primary-500'
        } focus:outline-none focus:ring-2 disabled:bg-neutral-100 disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="text-error-500 text-sm mt-1">{error}</p>}
      {hint && !error && <FieldHint>{hint}</FieldHint>}
    </div>
  );
};

export default Select;
